export default __webpack_public_path__ + "static/rocket-icon-e57195eea516da964d362fcd7e988c9f.svg";